const FullPageLoader = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/30 backdrop-blur-[1px]">
      <div className="flex flex-col items-center gap-4">
        <div className="h-14 w-14 animate-spin rounded-full border-4 border-white border-t-transparent" />
        <p className="text-white font-medium tracking-wide">Please wait...</p>
      </div>
    </div>
  );
};

export default FullPageLoader;
